import { render, staticRenderFns } from "./PerfilFormModal.vue?vue&type=template&id=482dafba&scoped=true"
import script from "./PerfilFormModal.vue?vue&type=script&lang=js"
export * from "./PerfilFormModal.vue?vue&type=script&lang=js"
import style0 from "./PerfilFormModal.vue?vue&type=style&index=0&id=482dafba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482dafba",
  null
  
)

export default component.exports